import { render, staticRenderFns } from "./ThgSignUp.vue?vue&type=template&id=e7b851b6"
import script from "./ThgSignUp.vue?vue&type=script&lang=ts"
export * from "./ThgSignUp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports